import React from "react";
import { Link } from "react-router-dom";
import { X, Plus, Minus, Trash2, ShoppingBag } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { Button } from "./ui/button";
import { useStore } from "../context/StoreContext";
import { useLang } from "../i18n/LanguageContext";
import { formatEUR } from "../lib/api";

export const CartDrawer = () => {
  const { cart, cartOpen, setCartOpen, updateQty, removeFromCart, cartTotal } = useStore();
  const { t } = useLang();
  return (
    <Sheet open={cartOpen} onOpenChange={setCartOpen}>
      <SheetContent side="right" className="glass border-border w-[90vw] sm:w-[420px] flex flex-col">
        <SheetHeader>
          <SheetTitle className="font-display text-xl flex items-center gap-2"><ShoppingBag className="h-5 w-5 text-cyanx" /> {t("common.checkout")}</SheetTitle>
        </SheetHeader>
        {cart.length === 0 ? (
          <div className="flex-1 flex flex-col items-center justify-center text-center gap-4">
            <p className="text-muted-foreground">{t("common.emptyCart")}</p>
            <Button asChild variant="secondary" onClick={() => setCartOpen(false)}><Link to="/shop">{t("common.continueShopping")}</Link></Button>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto -mx-2 px-2 py-4 space-y-3">
              {cart.map((item) => (
                <div key={item.slug} data-testid={`cart-item-${item.slug}`} className="flex gap-3 rounded-xl p-2 card-ceramic">
                  <div className="h-16 w-16 rounded-lg overflow-hidden bg-black/40 shrink-0">
                    {item.image ? <img src={item.image} alt={item.name} className="h-full w-full object-cover" /> : null}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium truncate">{item.name}</p>
                    <p className="text-xs text-muted-foreground font-mono">{formatEUR(item.price_eur)}</p>
                    <div className="mt-2 flex items-center gap-2">
                      <button onClick={() => updateQty(item.slug, item.qty - 1)} className="h-6 w-6 rounded-md hairline inline-flex items-center justify-center"><Minus className="h-3 w-3" /></button>
                      <span className="text-sm font-mono w-6 text-center">{item.qty}</span>
                      <button onClick={() => updateQty(item.slug, item.qty + 1)} className="h-6 w-6 rounded-md hairline inline-flex items-center justify-center"><Plus className="h-3 w-3" /></button>
                      <button onClick={() => removeFromCart(item.slug)} className="ml-auto text-muted-foreground hover:text-destructive"><Trash2 className="h-4 w-4" /></button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="border-t border-border pt-4 space-y-3">
              <div className="flex items-center justify-between">
                <span className="text-muted-foreground">{t("common.subtotal")}</span>
                <span className="font-display text-xl">{formatEUR(cartTotal)}</span>
              </div>
              <Button data-testid="cart-checkout-button" className="w-full btn-glow border-0 h-11">{t("common.checkout")}</Button>
              <p className="text-center text-xs text-muted-foreground">{t("product.shipping")}</p>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
};
